import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../media';

export const CardWrapper = styled.a`
	display: block;
	width: 100%;
	height: 100%;
	max-width: 204px;
	overflow: hidden;
	text-decoration: none;
	background-color: #fff;
	border: 1px solid rgb(0 0 0 / 20%);
	border-radius: 8px;
	${media.mobile} {
		display: flex;
		flex-direction: row-reverse;
		justify-content: space-between;
		max-width: 100%;
	}

	transition: box-shadow 0.2s ease-in;

	@media (hover) {
		&:hover {
			box-shadow: 0 1px 4px 0 rgb(0 0 0 / 16%), 0 2px 9px 0 rgb(0 0 0 / 2%);
		}
	}
`;

export const ImgWrapper = styled.div<{ isCatalogueCard: boolean }>`
	display: flex;
	flex-direction: row;
	justify-content: end;

	& img {
		width: ${({ isCatalogueCard }) => (isCatalogueCard ? '156px' : '112px')};
		height: ${({ isCatalogueCard }) => (isCatalogueCard ? '112px' : '80px')};
		${media.mobile} {
			width: 88px;
			height: 64px;
		}
	}
`;

export const ContentWrapper = styled.div<{ isCatalogueCard: boolean }>`
	display: flex;
	flex-direction: column;
	padding: ${({ isCatalogueCard }) => (isCatalogueCard ? '24px' : '20px')};
	row-gap: ${({ isCatalogueCard }) => (isCatalogueCard ? '8px' : '4px')};

	h3 {
		color: var(--text-primary);
	}

	p {
		color: var(--text-secondary);
	}

	${media.mobile} {
		padding: 16px;
		row-gap: 4px;
	}
`;

export const descriptionStyles = css`
	white-space: break-spaces;
	width: 180px;
	${media.mobile} {
		max-width: 175px;
	}
`;
